import { BTTO_PROFILE_COLORS } from "./elements";

export const BTTO_WALLET_GLASS = {
	cardBg:
		"linear-gradient(180deg, rgba(23, 28, 42, 0.92) 0%, rgba(10, 14, 26, 0.88) 100%)",
	panelBg: "rgba(31, 37, 54, 0.55)",
	panelHoverBg: "rgba(3, 98, 212, 0.14)",
	panelHoverBorder: "rgba(3, 98, 212, 0.35)",
	contentBg: "rgba(23, 28, 42, 0.45)",
	contentHoverBg: "rgba(37, 43, 61, 0.72)",
	border: "rgba(255, 255, 255, 0.08)",
	blur: "16px",
};

export const bettoWalletCssVariables = `
	--payment-gradient: linear-gradient(180deg, ${BTTO_PROFILE_COLORS.primary} 0%, ${BTTO_PROFILE_COLORS.primaryDark} 100%);
	--payment-modal-bg: ${BTTO_WALLET_GLASS.cardBg};
	--payment-modal-center-bg: ${BTTO_WALLET_GLASS.panelBg};
	--payment-page-wrapper-bg: ${BTTO_WALLET_GLASS.contentBg};
	--profile-page-wrapper-bg: ${BTTO_WALLET_GLASS.contentBg};
	--modal-input-bg: ${BTTO_PROFILE_COLORS.surfaceRaised};
	--input-bg-has-value: ${BTTO_PROFILE_COLORS.surfaceHover};
	--main-gradient: linear-gradient(180deg, ${BTTO_PROFILE_COLORS.primary} 0%, ${BTTO_PROFILE_COLORS.primaryDark} 100%);
	--profile-card-bg: ${BTTO_PROFILE_COLORS.surfaceRaised};
	--main-explosive: ${BTTO_PROFILE_COLORS.primary};
	--main-explosive-light: ${BTTO_PROFILE_COLORS.text};
	--main-color-dark: rgba(31, 37, 54, 0.55);
`;
